import React,  { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, unstable_usePrompt, useBlocker } from "react-router-dom";
// import {withRouter} from 'react-router';
// import { GoogleReCaptchaProvider, GoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Button, Box } from '@mui/material';
import Grid from '@mui/material/Grid';

import  ProgressCircle  from './errorHandling/ProgressCircle';
import ErrorDialog from './errorHandling/ErrorDialog';
import { trackPromise } from 'react-promise-tracker'
import { Create } from '../service/CreateProvisionalCMIR';

import { updatePerson, updateAddress, updateExportImport, updateMailShip, updateThirdParty, 
  updateShip, updateCarrier, updateFormIncomplete } from '../actions'

function HorizontalStepperButtons(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const activeStep = useSelector((state) => state.activeStep)
  const start = useSelector((state) => state.start)
  const person = useSelector((state) => state.person)
  const addresses = useSelector((state) => state.addresses)
  const thirdparty = useSelector((state) => state.thirdparty)
  const exportImport = useSelector((state) => state.exportImport)
  const carrier = useSelector((state) => state.carrier)
  const mailship = useSelector((state) => state.mailship)
  const ship = useSelector((state) => state.ship)
  const currencies = useSelector((state) => state.currencies)
  const coins = useSelector((state) => state.coins)
  const others = useSelector((state) => state.others)
  const review = useSelector((state) => state.review)
  const formIncomplete = useSelector((state) => state.formIncomplete)

  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [recaptchaTokenVerify, setRecaptchaTokenVerify] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [formIncompleteInternal, setFormIncompleteInternal] = useState(formIncomplete);

  useEffect(() => {
    setFormIncompleteInternal(true)
  }, [])

  useEffect(() => {
    setFormIncompleteInternal(formIncomplete)
  }, [formIncomplete])

  const { previousStep, allReqDone } = props

  // The condition to block navigation is when there are unsaved changes AND we aren't submitting the form
  const shouldBlock = formIncompleteInternal; 

  // Use useBlocker with a function that returns true to block, false to proceed
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      shouldBlock && currentLocation.pathname !== nextLocation.pathname
  );

  // Handle the custom confirmation UI when the blocker state is 'blocked'
  useEffect(() => {
    if (blocker.state === "blocked") {
      const confirmLeave = window.confirm("Are you sure you want to leave? All of the entered data will be lost.");
      if (confirmLeave) {
        blocker.proceed(); // Proceed with navigation
      } else {
        blocker.reset(); // Stay on the current page
      }
    }
  }, [blocker]); // Re-run when the blocker state changes

  const testOnClick = (event) => {
    trackPromise(new Promise((resolve, reject) =>{setTimeout(function(){resolve('result')},900000)}));
    props.updateStart();
  }

  const resetAll = () => {
    props.resetStep();
    props.resetStart();
    props.resetPerson();
    props.resetAddress();
    props.resetExportImport();
    props.resetMailShip();
    props.resetThirdParty();
    props.resetCurrencyItem();
    props.resetCoinItem();
    props.resetOtherItem();
    props.resetReviewSign();
    props.resetReceipt();
  }

  const onClickNav = () => {
    navigate('/confirm')
  }

// Block navigation when data has been entered
  // unstable_usePrompt({
  //   message: "Are you sure you want to leave? You have unsaved changes.",
  //   // The `when` condition can be a boolean or a function
  //   when: formIncompleteInternal,
  // })

  const setFormComplete = () => {
    // console.log('First event triggered.');
    if (props.activeStep === (props.start.pct === 'Y'? 6 : props.start.myselfOrSomeone === 'S'? 5 : 4)) {
      setFormIncompleteInternal(false);
    }
  }

  const onClick = () => {
    if (activeStep === 0) {
      //This is for the Get Started Panel
      // this.props.updateStart(this.props.start);
      dispatch(updateFormIncomplete(true))
      setFormIncompleteInternal(true)
    } else 
    if (props.activeStep === 1) {
      // console.log("person in stepper " + JSON.stringify(props.person))
      dispatch(updatePerson(props.person))
      dispatch(updateCarrier(props.person))
      dispatch(updateAddress(props.addresses));
      // props.updatePerson(props.person);
      // if (this.props.start.pct === 'N') {
      //   this.props.nextStep();
      // }
    // eslint-disable-next-line
    } else if ((props.activeStep === 2 && props.start.mailingOrPhysical === 'P')  ||
    // eslint-disable-next-line
                props.activeStep === 2 && props.start.pct === 'Y') {
      dispatch(updateExportImport(props.exportImport));
    } else if (props.activeStep === (props.start.pct === 'N'? 2 : 3) && props.start.mailingOrPhysical === 'M') {
      dispatch(updateMailShip(props.mailship, props.mailshipPerson));
      dispatch(updateAddress(props.addresses));
      // props.updateMailShip(props.mailship, props.mailshipPerson);
      // props.updateAddress();
      if (props.start.pct === 'Y') {
        dispatch(updateCarrier(props.carrier));
        dispatch(updateShip(props.ship));
        // props.updateCarrier(props.carrier);
        // props.updateShip(props.ship);
      }
      // console.log('addr in stepper ' + JSON.stringify(this.props.addresses))
    } else if (props.activeStep === (props.start.pct === 'N'? 3 : 4) && props.start.myselfOrSomeone === 'S') {
      dispatch(updateThirdParty(props.thirdparty));
      dispatch(updateAddress(props.addresses));
      // props.updateThirdParty(props.thirdparty);
      // props.updateAddress();
    } else if (props.activeStep === (props.start.pct === 'Y'? 5 : props.start.myselfOrSomeone === 'S'? 4 : 3)) {
      props.updateCurrencies(props.currencies);
      dispatch(updateFormIncomplete(false));
      // this.props.updateCoins(this.props.coins);
      // this.props.updateOthers(this.props.others);
    } else if (props.activeStep === (props.start.pct === 'Y'? 6 : props.start.myselfOrSomeone === 'S'? 5 : 4)) {    
      props.updateReviewSign();
      const filledAddresses = Object.values(addresses);

      //Check to see if address is pre-sliced
      if(filledAddresses.length === 5){
        //Remove unused addresses (third party & ship/receive        
        if (start.pct === 'N') {
          if (start.mailingOrPhysical !== 'M') {
            filledAddresses.splice(-2, 2);
          } else {
            filledAddresses.splice(-1, 1);
          }          
        }
        if (start.myselfOrSomeone !== 'S') {
          filledAddresses.splice(2, 1);
        }
        if (start.personalOrBusiness === 'B') {
          filledAddresses.splice(1, 1);
        }
      }
      // console.log('after in stepper ' + JSON.stringify(this.props.addresses))
      trackPromise(Create(start, person, filledAddresses, thirdparty, exportImport, 
          carrier, mailship, ship,
               currencies, coins, others, review))
             .then(confirmationNumber => {
                props.updateReceipt(confirmationNumber);
                navigate('/confirm');
             }).catch(err => {
                console.log("HorizontalStepperButtons - Error caught Error: ".concat(err," message: ", err.message)); setErrorMessage(err.message)
             });
    } else {     
      navigate('/')
    }
    if (props.activeStep !== (props.start.myselfOrSomeone === 'S'? 6 : 5))
      props.nextStep();
 }

 async function firstAsyncFunction() {
  // console.log("First function started (async)...");
  // Simulate an async operation (e.g., an API call)
  dispatch(updateFormIncomplete(false))
  await new Promise(resolve => setTimeout(resolve, 1000));
  // console.log("First function completed.");
}

 async function runSequentially() {
  await firstAsyncFunction(); // Wait here
  navigate('/confirm'); // Only runs after the await completes
}

  // render() {
    // const { classes, activeStep, start, previousStep, allReqDone } = this.props;
  const totalSteps = start.myselfOrSomeone === 'S'? 6 : 5;
    
  return (
    <Box sx={{ width: '100%' }}>          
      <Grid container sx={{ height: 100, justifyContent: 'flex-end', alignItems: 'center', flexDirection: 'row' }}>
        <Button variant="outlined" color="primary"            
          onClick={() => activeStep === 0? resetAll() : previousStep()}
          sx={{
            ml: 1,
            mr: 1,
            width: { xs: 112, sm: 150 },
            fontSize: '0.875rem',
            borderColor: "#324bb5",
            color: "#324bb5",
            transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
            '&:hover': {
              borderColor: '#1976d2',
              backgroundColor: 'rgba(50, 75, 181, 0.04)',
            },
            // fontWeight: "620",
          }}>
          {activeStep === 0 ? 'Reset' : 'Previous'}
        </Button>

        <ProgressCircle/>

        {errorMessage && <ErrorDialog errorMessage={errorMessage} onDismiss={() => setErrorMessage('')}/>}       
        
        
        {/* {start.pct === 'N' && */}
        <Button variant="contained" color="primary" onClick={() => { setFormComplete(); onClick(); }}
          disabled={(props.allReqDone !== undefined && !props.allReqDone)}
          sx={{
            ml: 1,
            mr: 1,
            width: { xs: 112, sm: 150 },
            fontSize: '0.875rem',
            // fontWeight: "620",
            backgroundColor: "#324bb5",
            '&:hover': {
              backgroundColor: '#1976d2',
            },
          }}>
            {activeStep === (props.start.pct === 'Y'? 6 : props.start.myselfOrSomeone === 'S'? 5 : 4) ? 'Complete' : 'Next'}
        </Button>
        {/* } */}
        
      </Grid>
    </Box>
  );
}

export default HorizontalStepperButtons;
